import { render, staticRenderFns } from "./PaymentTypeIcon.vue?vue&type=template&id=18e9a940&scoped=true"
import script from "./PaymentTypeIcon.vue?vue&type=script&lang=js"
export * from "./PaymentTypeIcon.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypeIcon.vue?vue&type=style&index=0&id=18e9a940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9a940",
  null
  
)

export default component.exports